import {
    React,Component, BootstrapTable, Redirect,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, useState, Tabs, Tab
} 
from '../../noser-hris-component';
import ReGeneratePayFileModal from './Modal/ReGeneratePayFileModal';

class ReGeneratePayFile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fade            :   true,
            color           :   "",
            isshow          :   false,
            message         :   "",
            userinfo        :   [],
            isloading       :   false,
            alerttype       :   "",
            loadingText     :   "",
            
            payPeriodListAutocomplete   :   [],
            clientListAutocomplete      :   [],
            bdoBatchNo	                :   "",
            mlBatchNo	                :   "",
            mbBatchNo	                :   "",
            palawanBatchNo	            :   "",
            ubBatchNo	                :   "",
            lbBatchNo	                :   "",
            gcashBatchNo                :   "",
            bdoDataList	                :   [],
            metroBankDataList	        :   [],
            mlListData	                :   [],
            palawanListData	            :   [],
            ubListData	                :   [],
            lbListData	                :   [],
            gcashListData	            :   [],
            fileName	                :   [],
            payrollTypeId	            :   [],
            selectedClientId            :   "",
            payPeriodSelectedId         :   "",
            isDisableBDO                :   true,
            isDisableMetro              :   true,
            isDisableML                 :   true,
            isDisablePalawan            :   true,
            isDisableUB                 :   true,
            isDisableLB                 :   true,
            isDisableGCash              :   true,
            isSpecial                   :   "0",
            isHold                      :   false,
            openModal                   :   false
        }
    }
    handleModalShow = (e) =>{
        this.setState({openModal:true})
        //let obj = {}
        this.child.initialize(e)
    }
    handleModalClose = (e) =>{
        this.setState({openModal:false})
        this.handleClickSearch(e)
    }
    componentDidMount() {
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.getClientList();
    }

    getClientList(){
        this.setState({
            isloading   :   true
        })
        const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}

        const getParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
        }
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList", getParams)
        .then(res => {
            sleep(1000).then(() => {
                this.setState({
                    clientListAutocomplete      :   res.data.clients ? res.data.clients     :   [],
                    isloading                   :   false
                })
            })
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    };

    onChangeClientList = (e) => {
        if(e.length == 0) {
            this.state.selectedClientId     =   ""
            this.state.selectedClientName   =   ""
            return
        } 
        this.state.selectedClientId         =   e[0].id
        this.state.selectedClientName       =   e[0].name
        this.state.isSpecial = e[0].isSpecial
        this.GetPayPeriodList()
    }
    
    GetPayPeriodList = async() => {
        
        this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
            "EmployeeId"    :   this.state.selectedEmployeeId ? this.state.selectedEmployeeId : "",
            "IsProcessed"   :   "1"
         };
         let api = ""
        if(this.state.isSpecial==="0"){
            api = "Timekeeping/GetPayrollPeriods"
        }
        else{
            api = "Timekeeping/GetSpecialPayrollPeriods"
        }
        await axios
             .post(
                AppConfiguration.Setting().noserapiendpoint + api,  params
             )
             .then(res => {
                const data = res.data;
                this.setState({
                    payPeriodListAutocomplete   :   data.payrollPeriods,
                    isloading       :   false 
                })
             })
    }


    onChangePayPeriod = (e) => {

        if(e.length == 0) {
            this.state.payPeriodSelectedId = ""
            this.state.selectedPayPeriodName = ""
            return
        } 

        this.state.payPeriodSelectedId = e[0].periodId
        this.state.selectedPayPeriodName = e[0].payPeriod
    }

    onChangeBDOBatchNo = (e) => {
        this.setState({
            bdoBatchNo	:   e.target.value
        })
    }

    onChangeMlBatchNo = (e) => {
        this.setState({
            mlBatchNo	:   e.target.value
        })
    }

    onChangeMbBatchNo = (e) => {
        this.setState({
            mbBatchNo	:   e.target.value
        })
    }

    onChangepalawanBatchNo = (e) => {
        this.setState({
            palawanBatchNo	:   e.target.value
        })
    }

    onChangeubBatchNo = (e) => {
        this.setState({
            ubBatchNo	:   e.target.value
        })
    }
    onChangelbBatchNo = (e) => {
        this.setState({
            lbBatchNo	:   e.target.value
        })
    }
    onChangegcashBatchNo = (e) => {
        this.setState({
            gcashBatchNo	:   e.target.value
        })
    }
    handleChangedCB = (e) =>{
        this.setState({[e.target.name]: e.target.checked})
    }
    handleClickGenerate = async(e) => {
        let obj = {}
        
        obj = {
            clientId : this.state.selectedClientId,
            clientName : this.state.selectedClientName,
            periodId : this.state.payPeriodSelectedId,
            periodName : this.state.selectedPayPeriodName,
            bdoBatchNo : this.state.bdoBatchNo,
            mlBatchNo : this.state.mlBatchNo,
            mbBatchNo : this.state.mbBatchNo,
            palawanBatchNo : this.state.palawanBatchNo,
            ubBatchNo : this.state.ubBatchNo,
            lbBatchNo : this.state.lbBatchNo,
            clientListAutocomplete : this.state.clientListAutocomplete
        }
        this.handleModalShow(obj)
       
        // else{
        //     this.ProcessPayrollFile(e)
        // }
    }
    ProcessPayrollFile = async(e) =>{
        this.setState({isloading:true})

        if(this.state.selectedClientId==""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select client.",
                fade            :   true
            });
            return
        }

        if(this.state.payPeriodSelectedId==""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select period or cut off.",
                fade            :   true
            });
            return
        }

        const getParams = {
            "IpAddress"             :   "0.0.0.0",
            "ClientId"              :   this.state.selectedClientId,
            "UserId"                :   this.state.userinfo.userId,
            "PayPeriodId"           :   this.state.payPeriodSelectedId,
            "BDOBatchNumber"        :   this.state.bdoBatchNo,
            "MLBatchNumber"         :   this.state.mlBatchNo,
            "MetroBankBatchNumber"  :   this.state.mbBatchNo,
            "PalawanBatchNumber"    :   this.state.palawanBatchNo,
            "UBBatchNumber"         :   this.state.ubBatchNo,
            "LBBatchNumber"         :   this.state.lbBatchNo,
            "GCashBatchNumber"      :   this.state.gcashBatchNo,
            "IsHold"                :   this.state.isHold ? "1" : "0"
        }

        console.log("Submit Generate params")
        console.log(getParams)

        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/ProcessPayrollFiles", getParams)
        .then(res => {
            const data = res.data
            console.log("Process Payroll Files")
            console.log(data)
            if(data.status=="1"){
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Success!",
                    isshow          :   true,
                    color           :   "success",
                    message         :   data.message,
                    fade            :   true
                });
                this.handleClickSearch(e)
            }
            else{
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   data.message,
                    fade            :   true
                })
            }
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    handleClickSearch = () => {
        this.setState({isloading:true})

        if(this.state.selectedClientId==""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select client.",
                fade            :   true
            });
            return
        }

        if(this.state.payPeriodSelectedId==""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select period or cut off.",
                fade            :   true
            });
            return
        }

        const getParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
            "PayPeriodId"    :   this.state.payPeriodSelectedId,
        }

        console.log("Submit search params")
        console.log(getParams)

        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/GetPayrollFiles", getParams)
        .then(res => {
            const data = res.data
            console.log("Get Payroll Files")
           /*  this.state.mlListData = data.payrollFilesML */
            console.log(data)
            let mlDataList = [];
            let mlDataLists = [];
            
            
            
            this.setState({
                bdoDataList         :   data.payrollFilesBDO,
                metroBankDataList   :   data.payrollFilesMetroBank,
                mlListData          :   data.payrollFilesML,
                palawanListData     :   data.payrollFilesPalawan,
                ubListData          :   data.payrollFilesUB,
                lbListData          :   data.payrollFilesLB,
                gcashListData       :   data.payrollFilesGCash,
                isloading           :   false,
            })
            /* for(let j = 0; j < data.payrollFilesML[0].payrollFileDetails.length; j++){
                const obj = {
                    "payCardNumber" : data.payrollFilesML[0].payrollFileDetails[j].payCardNumber,
                }
                mlDataList.push(obj)
            }
            this.setState({
                mlListData : mlDataList
            }) */
            /* mlDataList.push(objList) */
            
            if(data.status=="0"){
                this.setState({
                    isloading       :   false,
                    alerttype       :   "Error!",
                    isshow          :   true,
                    color           :   "danger",
                    message         :   data.message,
                    fade            :   true
                })
            }
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }

    downloadHandleClick = (row) =>{
        this.state.fileName        =   row.fileName
        this.state.payrollTypeId   =   row.payrollTypeId

        const getParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.selectedClientId,
            "UserId"        :   this.state.userinfo.userId,
            "PayrollTypeId" :   this.state.payrollTypeId,
            "FileName"      :   this.state.fileName
        }

        console.log("Start get params")
        console.log(getParams)
        console.log(" End get params")

        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DownloadPayrollFile", getParams,{'responseType': 'blob'})
        .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', row.fileName);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    handleDeleteBDO = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.bdoDataList.length; i++) {
            if (this.state.bdoDataList[i]["isDeleted"] == 1) {
                let obj = this.state.bdoDataList[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeleteMetro = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.metroBankDataList.length; i++) {
            if (this.state.metroBankDataList[i]["isDeleted"] == 1) {
                let obj = this.state.metroBankDataList[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeleteML = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.mlListData.length; i++) {
            if (this.state.mlListData[i]["isDeleted"] == 1) {
                let obj = this.state.mlListData[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeletePalawan = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.palawanListData.length; i++) {
            if (this.state.palawanListData[i]["isDeleted"] == 1) {
                let obj = this.state.palawanListData[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeleteUB = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.ubListData.length; i++) {
            if (this.state.ubListData[i]["isDeleted"] == 1) {
                let obj = this.state.ubListData[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeleteLB = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.lbListData.length; i++) {
            if (this.state.lbListData[i]["isDeleted"] == 1) {
                let obj = this.state.lbListData[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    handleDeleteGCASH = (e) => {
        this.setState({isloading:true,isDisable:true})
        
        let payrollfiles  = []     
        
        for (let i = 0; i < this.state.gcashListData.length; i++) {
            if (this.state.gcashListData[i]["isDeleted"] == 1) {
                let obj = this.state.gcashListData[i]
                payrollfiles.push(obj);
            } 
        }

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "payrollFiles":payrollfiles
        };


        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DeletePayrollFiles", params)
            .then(res => {
                //this.refreshList();
                const data = res.data;
                if(data.status=="1"){
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Success!",
                        isshow          :   true,
                        color           :   "success",
                        message         :   data.message,
                        fade            :   true
                    });
                    this.handleClickSearch(e)
                }
                else{
                    this.setState({
                        isloading       :   false,
                        alerttype       :   "Error!",
                        isshow          :   true,
                        color           :   "danger",
                        message         :   data.message,
                        fade            :   true
                    })
                }
             })
             .catch(error=>{
                this.setState(
                {
                    isLoading:false,
                    AlertType:"Error! ",
                    Show:true,
                    Color:"danger",
                    Message: "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    Fade:true
                })
            })
    }
    render(){
        const columnBDO = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
            
        ]

        const columnMetroBank = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
            
        ]


        const columnML = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
        ]
        const columnPalawan = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
        ]
        const columnUB = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
        ]
        const columnLB = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
        ]

        const columnGCASH = [
            {
                text        :   'PERIOD',
                editable    :   false,
                dataField   :   'payPeriod',
                headerStyle: (colum, colIndex) => {
                    return { width:'8%',textAlign: 'left' }},
                style:{textAlign:'left'}
            },
            {
                text        :   "CLIENT NAME",
                editable    :   false,
                dataField   :   "client",
                headerStyle: (colum, colIndex) => {
                    return { width:'28%' }},
            },
            {
                text        :   'REFERENCE NUMBER',
                editable    :   false,
                dataField   :   'referenceNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'16%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   'BATCH NUMBER',
                editable    :   false,
                dataField   :   'batchNumber',
                headerStyle: (colum, colIndex) => {
                    return { width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
            },
            {
                text        :   "TRANSACTION DATE",
                editable    :   false,
                dataField   :   "txnDate",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'center'}
                
            },
            {
                text        :   "TOTAL TXN",
                editable    :   false,
                dataField   :   "totalTxn",
                headerStyle: (colum, colIndex) => {
                    return {width:'8%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "TOTAL AMOUNT",
                editable    :   false,
                dataField   :   "totalTxnAmount",
                headerStyle: (colum, colIndex) => {
                    return {width:'10%',textAlign: 'center' }},
                style:{textAlign:'right'}
            },
            {
                text        :   "ACTION",
                editable    :   false,
                dataField   :   "databasePkey",
                formatter   :   (cell, row, isSelect) => {
                    this.state.fileNameLinkMetro = row.fileName
                    if (row)
                    return (
                        <Button style={{height:'16px',paddingTop:'0',marginTop:'-3px',fontSize:'11px'}}
                            variant="link" onClick={e => this.downloadHandleClick(row)}
                        >download file</Button>
                    );
                },
                headerStyle : () => {
                    return { width  : "10%",textAlign: 'center' };
                },
                style:{textAlign:'center'}
            },
        ]

        const selectRowBDO = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableBDO=true
                this.state.bdoDataList.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableBDO =  false
                })
                this.setState({isDisableBDO:isDisableBDO})
            }
        };
        const selectRowMetrobank = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableMetro=true
                this.state.metroBankDataList.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableMetro =  false
                })
                this.setState({isDisableMetro:isDisableMetro})
            }
        };
        const selectRowML = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableML=true
                this.state.mlListData.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableML =  false
                })
                this.setState({isDisableML:isDisableML})
            }
        };

        const selectRowPalawan = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisablePalawan=true
                this.state.palawanListData.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisablePalawan =  false
                })
                this.setState({isDisablePalawan:isDisablePalawan})
            }
        };
        const selectRowUB = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableUB=true
                this.state.ubListData.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableUB =  false
                })
                this.setState({isDisableUB:isDisableUB})
            }
        };
        const selectRowLB = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableLB=true
                this.state.lbListData.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableLB =  false
                })
                this.setState({isDisableLB:isDisableLB})
            }
        };
        const selectRowGCASH = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisableGCash=true
                this.state.gcashListData.map(function(item,i){
                    if(item.id===row.id)
                    {
                        item.isDeleted = isSelect ? "1" : "0"
                    }
                    if (item.isDeleted=="1")
                    isDisableGCash =  false
                })
                this.setState({isDisableGCash:isDisableGCash})
            }
        };

        const columnBDOExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Pay Card Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]

        const columnMetroBankExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Pay Card Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]

        const columnMLExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Reference Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Sender Last Name",
                editable    :   false,
                dataField   :   "senderLastName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Sender First Name",
                editable    :   false,
                dataField   :   "senderFirstName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "Sender Middle Name",
                editable    :   false,
                dataField   :   "senderMiddleName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "Sender Address",
                editable    :   false,
                dataField   :   "senderAddress",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Sender Contact No",
                editable    :   false,
                dataField   :   "senderContactNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "Receiver Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Receiver Address",
                editable    :   false,
                dataField   :   "receiverAddress",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Receiver Contact No",
                editable    :   false,
                dataField   :   "receiverContactNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]

        const columnPalawanExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Sender FN",
                editable    :   false,
                dataField   :   "senderLastName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Sender LN",
                editable    :   false,
                dataField   :   "senderFirstName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "Sender MPN",
                editable    :   false,
                dataField   :   "senderContactNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "To Branch",
                editable    :   false,
                dataField   :   "senderAddress",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                
            },
            {
                text        :   "First Name",
                editable    :   false,
                dataField   :   "receiverFirstName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Middle Initial",
                editable    :   false,
                dataField   :   "receiverMiddleName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Last Name",
                editable    :   false,
                dataField   :   "receiverLastName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "MPN",
                editable    :   false,
                dataField   :   "receiverContactNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%',whiteSpace:'nowrap' }},
                style:{whiteSpace:'nowrap'}
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]
        const columnUBExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Pay Card Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]
        const columnLBExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Pay Card Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]
        const columnGCashExpand = [
            {
                text        :   "PAYROLL REF NO",
                editable    :   false,
                dataField   :   "referenceNo",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Member Name",
                editable    :   false,
                dataField   :   "memberName",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Pay Card Number",
                editable    :   false,
                dataField   :   "payCardNumber",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
            {
                text        :   "Amount",
                editable    :   false,
                dataField   :   "amount",
                headerStyle: (colum, colIndex) => {
                    return {width:'15%' }},
                
            },
        ]

        const expandBDORowDetails = {
            onlyOneExpanding: true,
            renderer: row => 
            (
                <BootstrapTable
                    keyField = "id"
                    data = { row.payrollFileDetails }
                    columns = { columnBDOExpand }
                    rowClasses="noser-table-row-class"
                    striped
                    hover
                    condensed
                    expandRow
                    wrapperClasses="table-responsive"
                    rowClasses="noser-table-row-class"
                    noDataIndication={ () => <div>No Payroll details.</div> }
                /> 
            ),
            showExpandColumn: true,
            
          };

          const expandMetroBankRowDetails = {
              onlyOneExpanding: true,
              renderer: row => 
              (
                  <BootstrapTable
                      keyField = "id"
                      data = { row.payrollFileDetails }
                      columns = { columnMetroBankExpand }
                      rowClasses="noser-table-row-class"
                      striped
                      hover
                      condensed
                      expandRow
                      wrapperClasses="table-responsive"
                      rowClasses="noser-table-row-class"
                      noDataIndication={ () => <div>No Payroll details.</div> }
                  /> 
              ),
              showExpandColumn: true,
              
            };

            const expandMLRowDetails = {
                onlyOneExpanding: true,
                renderer: row => 
                (
                    <BootstrapTable
                        keyField = "id"
                        data = { row.payrollFileDetails }
                        columns = { columnMLExpand }
                        rowClasses="noser-table-row-class"
                        striped
                        hover
                        condensed
                        expandRow
                        wrapperClasses="table-responsive"
                        rowClasses="noser-table-row-class"
                        noDataIndication={ () => <div>No Payroll details.</div> }
                    /> 
                ),
                showExpandColumn: true,
                
              };

              const expandPalawanRowDetails = {
                onlyOneExpanding: true,
                renderer: row => 
                (
                    <BootstrapTable
                        keyField = "id"
                        data = { row.payrollFileDetails }
                        columns = { columnPalawanExpand }
                        rowClasses="noser-table-row-class"
                        striped
                        hover
                        condensed
                        expandRow
                        wrapperClasses="table-responsive"
                        rowClasses="noser-table-row-class"
                        noDataIndication={ () => <div>No Payroll details.</div> }
                    /> 
                ),
                showExpandColumn: true,
                
            };
            const expandUBRowDetails = {
                onlyOneExpanding: true,
                renderer: row => 
                (
                    <BootstrapTable
                        keyField = "id"
                        data = { row.payrollFileDetails }
                        columns = { columnUBExpand }
                        rowClasses="noser-table-row-class"
                        striped
                        hover
                        condensed
                        expandRow
                        wrapperClasses="table-responsive"
                        rowClasses="noser-table-row-class"
                        noDataIndication={ () => <div>No Payroll details.</div> }
                    /> 
                ),
                showExpandColumn: true,
                
            };
            const expandLBRowDetails = {
                onlyOneExpanding: true,
                renderer: row => 
                (
                    <BootstrapTable
                        keyField = "id"
                        data = { row.payrollFileDetails }
                        columns = { columnLBExpand }
                        rowClasses="noser-table-row-class"
                        striped
                        hover
                        condensed
                        expandRow
                        wrapperClasses="table-responsive"
                        rowClasses="noser-table-row-class"
                        noDataIndication={ () => <div>No Payroll details.</div> }
                    /> 
                ),
                showExpandColumn: true,
                
            };
            const expandGCashRowDetails = {
                onlyOneExpanding: true,
                renderer: row => 
                (
                    <BootstrapTable
                        keyField = "id"
                        data = { row.payrollFileDetails }
                        columns = { columnGCashExpand }
                        rowClasses="noser-table-row-class"
                        striped
                        hover
                        condensed
                        expandRow
                        wrapperClasses="table-responsive"
                        rowClasses="noser-table-row-class"
                        noDataIndication={ () => <div>No Payroll details.</div> }
                    /> 
                ),
                showExpandColumn: true,
                
            };

        return(
            <div>
                <Banner/>

                <Container className="mt-5" fluid>
                    <Card>
                        <Card.Header>Payroll >> Re-Generate Payroll File</Card.Header>
                        <Card.Body>
                            <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                <div className={this.state.color}></div> 
                                {this.state.message}
                            </Alert>
                            <Form.Row>
                                <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                    <Typeahead
                                        labelKey='name'
                                        id="basic-example"
                                        onChange={this.onChangeClientList}
                                        options={this.state.clientListAutocomplete}
                                        placeholder="Select Client"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                    <Typeahead
                                        labelKey='payPeriod'
                                        id="basic-example"
                                        onChange={this.onChangePayPeriod}
                                        options={this.state.payPeriodListAutocomplete}
                                        placeholder="Select Pay Period"
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="bdoBatchNo"
                                        value={this.state.bdoBatchNo}
                                        placeholder="BDO Batch No"
                                        onChange={this.onChangeBDOBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="mlBatchNo"
                                        value={this.state.mlBatchNo}
                                        placeholder="ML Batch No"
                                        onChange={this.onChangeMlBatchNo}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="mbBatchNo"
                                        value={this.state.mbBatchNo}
                                        placeholder="Metro Bank Batch No"
                                        onChange={this.onChangeMbBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="palawanBatchNo"
                                        value={this.state.palawanBatchNo}
                                        placeholder="PALAWAN Batch No"
                                        onChange={this.onChangepalawanBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="ubBatchNo"
                                        value={this.state.ubBatchNo}
                                        placeholder="UB Batch No"
                                        onChange={this.onChangeubBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="lbBatchNo"
                                        value={this.state.lbBatchNo}
                                        placeholder="LB Batch No"
                                        onChange={this.onChangelbBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                    <Form.Control 
                                        type="text" 
                                        autoComplete="off" 
                                        name="gcashBatchNo"
                                        value={this.state.gcashBatchNo}
                                        placeholder="GCASH Batch No"
                                        onChange={this.onChangegcashBatchNo}
                                        maxLength="3"
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                            <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                <Form.Check type="checkbox" 
                                    label="IS HOLD" 
                                    id="isHold"
                                    name="isHold"
                                    onChange={this.handleChangedCB}
                                    style={{fontWeight : "bold",marginLeft:"2px"}}
                                    checked={this.state.isHold}
                                />
                            </Form.Group>
                            </Form.Row>
                            <ButtonToolbar className="mt-5" sm={12}>
                                <Button className="ml-auto noser-button-mr1" variant="success" onClick={this.handleClickSearch}>
                                    Search
                                </Button>
                                <Button className='noser-button' variant="success"  onClick={this.handleClickGenerate}>
                                    Generate
                                </Button>
                            </ButtonToolbar>

                            <Tabs className="mt-3" defaultActiveKey="default" transition={false} id="noanim-tab-example">
                                <Tab eventKey="default" title="BDO">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.bdoDataList }
                                                    columns = { columnBDO }
                                                    selectRow = { selectRowBDO }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandBDORowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteBDO} disabled={this.state.isDisableBDO}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="metrobank" title="METROBANK">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.metroBankDataList }
                                                    columns = { columnMetroBank }
                                                    selectRow = { selectRowMetrobank }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandMetroBankRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteMetro} disabled={this.state.isDisableMetro}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="ml" title="ML">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.mlListData }
                                                    /* data = { this.state.mlListData } */
                                                    columns = { columnML }
                                                    selectRow = { selectRowML }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandMLRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteML} disabled={this.state.isDisableML}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="palawan" title="PALAWAN">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.palawanListData }
                                                    /* data = { this.state.mlListData } */
                                                    columns = { columnPalawan }
                                                    selectRow = { selectRowPalawan }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandPalawanRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeletePalawan} disabled={this.state.isDisablePalawan}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="ub" title="UB">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.ubListData }
                                                    columns = { columnUB }
                                                    selectRow = { selectRowUB }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandUBRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteUB} disabled={this.state.isDisableUB}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="lb" title="LB">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.lbListData }
                                                    columns = { columnLB }
                                                    selectRow = { selectRowLB }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandLBRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteLB} disabled={this.state.isDisableLB}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>

                                <Tab eventKey="gcash" title="GCASH">
                                    <Form.Row>
                                        <Form.Group controlId="formGridPassword" as={Col}>
                                            <Card className="card-tab-no-border">
                                                <div className="card-header-tab"></div>
                                                <BootstrapTable
                                                    keyField = "id"
                                                    data = { this.state.gcashListData }
                                                    columns = { columnGCASH }
                                                    selectRow = { selectRowGCASH }
                                                    striped
                                                    hover
                                                    condensed
                                                    expandRow={ expandGCashRowDetails }
                                                    noDataIndication={ () => <div>No record found.</div> }
                                                />
                                            </Card>
                                        </Form.Group>
                                    </Form.Row>
                                    <ButtonToolbar className="mt-5" sm={12}>
                                        <Button className="ml-auto noser-button" variant="success" onClick={this.handleDeleteGCASH} disabled={this.state.isDisableGCash}>
                                            DELETE
                                        </Button>
                                    </ButtonToolbar>
                                </Tab>
                            </Tabs>

                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
                <ReGeneratePayFileModal 
                    show={this.state.openModal}
                    onHide={this.handleModalClose}
                    onRefModal={ref => (this.child = ref)}
                />
            </div>
        )
    }

}



export  default ReGeneratePayFile